'use es6';

import { handleActions } from 'redux-actions';
import { REQUEST_PAYMENTS, RECEIVE_PAYMENTS, SUCCESS_GETTING_PAYMENTS, FAILED_GETTING_PAYMENTS, REQUEST_PAYMENT_ELIGIBILITY, RECEIVE_PAYMENT_ELIGIBILITY, FAILED_GETTING_PAYMENT_ELIGIBILITY, REQUEST_CHECKOUT_SESSION_PREVIEW, RECEIVE_CHECKOUT_SESSION_PREVIEW, SUCCESS_GETTING_CHECKOUT_SESSION_PREVIEW, FAILED_GETTING_CHECKOUT_SESSION_PREVIEW, UPDATE_TOGGLE_STATE } from 'FormsUI/actions/Payments';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
const initalState = {
  paymentsData: [],
  paymentEligibility: {},
  checkoutSessionPreview: {},
  toggleState: false,
  dataRequestState: RequestState.NOT_REQUESTED,
  eligibilityRequestState: RequestState.NOT_REQUESTED
};
export default handleActions({
  [REQUEST_PAYMENTS]: state => Object.assign({}, state, {
    paymentsData: [],
    dataRequestState: RequestState.REQUESTED
  }),
  [RECEIVE_PAYMENTS]: (state, {
    payload: {
      results
    }
  }) => Object.assign({}, state, {
    paymentsData: results
  }),
  [SUCCESS_GETTING_PAYMENTS]: state => Object.assign({}, state, {
    dataRequestState: RequestState.SUCCEEDED
  }),
  [FAILED_GETTING_PAYMENTS]: state => Object.assign({}, state, {
    dataRequestState: RequestState.FAILED
  }),
  [REQUEST_PAYMENT_ELIGIBILITY]: state => Object.assign({}, state, {
    paymentEligibility: {},
    eligibilityRequestState: RequestState.REQUESTED
  }),
  [RECEIVE_PAYMENT_ELIGIBILITY]: (state, {
    payload
  }) => Object.assign({}, state, {
    paymentEligibility: payload,
    eligibilityRequestState: RequestState.SUCCEEDED
  }),
  [FAILED_GETTING_PAYMENT_ELIGIBILITY]: state => Object.assign({}, state, {
    eligibilityRequestState: RequestState.FAILED
  }),
  [UPDATE_TOGGLE_STATE]: (state, {
    toggleState
  }) => Object.assign({}, state, {
    toggleState
  }),
  [REQUEST_CHECKOUT_SESSION_PREVIEW]: (state, {
    paymentSessionTemplateId
  }) => Object.assign({}, state, {
    checkoutSessionPreview: Object.assign({}, state.checkoutSessionPreview, {
      [paymentSessionTemplateId]: {
        requestState: RequestState.REQUESTED,
        id: null,
        error: null
      }
    })
  }),
  [RECEIVE_CHECKOUT_SESSION_PREVIEW]: (state, {
    paymentSessionTemplateId,
    payload
  }) => Object.assign({}, state, {
    checkoutSessionPreview: Object.assign({}, state.checkoutSessionPreview, {
      [paymentSessionTemplateId]: Object.assign({}, state.checkoutSessionPreview[paymentSessionTemplateId], {
        id: payload
      })
    })
  }),
  [SUCCESS_GETTING_CHECKOUT_SESSION_PREVIEW]: (state, {
    paymentSessionTemplateId
  }) => Object.assign({}, state, {
    checkoutSessionPreview: Object.assign({}, state.checkoutSessionPreview, {
      [paymentSessionTemplateId]: Object.assign({}, state.checkoutSessionPreview[paymentSessionTemplateId], {
        requestState: RequestState.SUCCEEDED
      })
    })
  }),
  [FAILED_GETTING_CHECKOUT_SESSION_PREVIEW]: (state, {
    paymentSessionTemplateId,
    error
  }) => Object.assign({}, state, {
    checkoutSessionPreview: Object.assign({}, state.checkoutSessionPreview, {
      [paymentSessionTemplateId]: {
        requestState: RequestState.FAILED,
        error
      }
    })
  })
}, initalState);